import { createFileRoute } from "@tanstack/react-router";
import ChangePasswordPage from "@/site/pages/change-password";

// Old app's password change lived at /change_password (section tab "Password").
//
// It was ALSO the landing of legacy's password-RESET mail: `/change_password?t=&e=`,
// where the pair was a never-expiring, non-single-use credential derived from the
// address (PRD 13 O19, decided 2026-09-16: retire them). Every reset link ever
// mailed dies at cutover regardless of timing, so land those softly on /forgot
// with an explanation rather than on a login wall. Only the `t`+`e` shape is
// intercepted — the account page itself is unchanged.
// The intercept lives in `__root.tsx` (its login bounce runs before any route's
// beforeLoad); the account page itself is unchanged.
export const Route = createFileRoute("/change_password")({
  component: ChangePasswordPage,
});
